import React, { useState } from 'react';
import { IpaType } from '../../phonemes/ipa';
import { speakSegment } from '../speakSegment';
import { FormantsChart } from './FormantsChart';
import { allFormants, nasalFormants } from '../../phonemes/formants';
import { ipaToSynthSymbols } from '../../speak/exact';
import { ipaToSynth } from '../../speak/ipaToSynth';

/** show nasals on a formants chart w/ their synth approximations that you can hear */
export function SynthNasalFormants(props: { width?: number, height?: number, onlyIpa?: boolean }) {
  const [formants] = useState({ ...allFormants, ...nasalFormants });

  function lookup(ipa: IpaType): string {
    if (props.onlyIpa) {
      return ipa;
    }
    const speak = ipaToSynthSymbols[ipa] ?? ipaToSynth(ipa).speak;
    return ipa + ':' + speak;
  }

  function whatColor(ipa: IpaType): string {
    return nasalFormants[ipa] ? 'rgb(190, 0, 0)' : 'grey';
  }

  return <FormantsChart formants={formants} lookup={lookup}
    width={props.width ?? 600} height={props.height ?? 300}
    clicked={speakSegment} whatColor={whatColor} />;
}
